import React from 'react';

import './Template.scss';

/**
 * Wrap a component into the primary site template (Header and Nav component)
 * @param {*React.Component} ChildrenComponent
 * @param {*boolean} hideBreadcrumb
 */
export const withTemplate = (ChildrenComponent, TemplateComponent, templateProps) => {
    class WithMainTemplate extends React.Component {
        render() {
            return (
                <TemplateComponent {...templateProps}>
                    <ChildrenComponent {...this.props} />
                </TemplateComponent>
            );
        }
    }
    withTemplate.displayName = `WithMainTemplate(${getDisplayName(ChildrenComponent)})`;
    return WithMainTemplate;
};

const getDisplayName = WrappedComponent => {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};



// WEBPACK FOOTER //
// ./src/components/template/withTemplate.js